import { render } from "./MessaInMoraPec.vue?vue&type=template&id=554fde28"
import script from "./MessaInMoraPec.vue?vue&type=script&lang=js"
export * from "./MessaInMoraPec.vue?vue&type=script&lang=js"

import "./MessaInMoraPec.vue?vue&type=style&index=0&id=554fde28&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__